module.exports = __webpack_public_path__ + "media/svgs/oval-line-da398c4f.svg";